import { CupsPriceLevelService } from "@/modules/CupsPriceLevels/services/CupsPriceLevelService";
import { FORM_TEMP_CONSTANTS } from "@/modules/FormTemplate/constants/FormTemplateConstants";
import { FORMS_CONSTANTS } from "@/modules/Forms/constants/FormsConstants";
import { GroupFullSchema } from "@/modules/InfoGroup/models/GroupFullSchema";
import {
  LIST_ACCESS,
  LIST_CONSTANTS
} from "@/modules/List/constants/ListConstants";
import { ListService } from "@/modules/List/services/ListService";
import { ORDER_CONSTANTS } from "@/modules/Orders/constants/OrderConstants";
import { FieldOrder } from "@/modules/Orders/models/FieldOrder";
import { OrderListDataView } from "@/modules/Orders/models/OrderListDataView";
import { OrderService } from "@/modules/Orders/services/OrderService";
import {
  MAX_WIDTH_MODALS,
  PROFILE_CONSTANTS
} from "@/modules/Profile/constants/ProfileConstants";
import { SERVICES_CONTANTS } from "@/modules/Services/constants/ServicesConstants";
import ModalTemplate from "@/shared/components/ModalTemplate/ModalTemplate.vue";
import ModifVJsfInput from "@/shared/components/ModifVJsfInput/ModifVJsfInput.vue";
import Snackbar from "@/shared/components/Snackbar/Snackbar";
import {
  FORM_CONSTANTS,
  FORM_MESSAGES,
  FORM_VALIDATORS,
  TYPE_FIELDS,
  VJSF_OPTIONS
} from "@/shared/constants/FormConstants";
import { GENERAL_CONSTANTS } from "@/shared/constants/GeneralConstants";
import { STYLE_CLASSES } from "@/shared/constants/StyleConstants";
import { ArrayByKeys } from "@/shared/models/ArrayByKeys";
import { FullSchema } from "@/shared/models/FullSchema";
import { PhoneModel } from "@/shared/models/PhoneModel";
import { PhoneSchema } from "@/shared/models/PhoneSchema";
import { TitleList } from "@/shared/models/TitleList";
import { Utils } from "@/shared/utils/utils";
import { Http } from "@status/codes";
import Vue from "vue";
import { Component, Inject, Prop, Watch } from "vue-property-decorator";
import {
  FIELDS_MAPED_FROM_USER,
  FIELDS_ORDER_TO_PRELOAD,
  MEDICAL_ORDER_ACCESS,
  MEDICAL_ORDER_CONSTANTS
} from "../../constants/MedicalOrderConstants";
import { FieldMedicalOrderSchemaKey } from "../../models/FieldMedicalOrderSchemaKey";
import { MedicalOrderField } from "../../models/MedicalOrderField";
import { MedicalOrderFieldsMap } from "../../models/MedicalOrderFieldsMap";
import { MedicalOrderPreviewEventTimelineModel } from "../../models/MedicalOrderPreviewEventTimelineModel";
import { MedicalOrderUpdateModel } from "../../models/MedicalOrderUpdateModel";
import { MedicalOrderService } from "../../services/MedicalOrderService";
import { UserService } from "@/modules/User/services/UserService";
import lodash from "lodash";
import { UserInformationModel } from "@/modules/User/models/UserInformationModel";
import { KeyValue } from "@/shared/models/KeyValue";
import { MedicalOrderData } from "../../models/MedicalOrderData";
import { CampusService } from "@/modules/Campus/services/CampusService";

@Component({
  name: "MedicalOrderDetail",
  components: {
    ModifVJsfInput,
    ModalTemplate
  }
})
export default class MedicalOrderDetail extends Vue {
  @Inject() orderService!: OrderService;
  @Inject() listService!: ListService;
  @Inject() cupsPriceLevelService!: CupsPriceLevelService;
  @Inject() medicalOrderService!: MedicalOrderService;
  @Inject() userService!: UserService;
  @Inject() campusService!: CampusService;

  @Prop() cupsId!: string;
  @Prop() medicalOrder!: MedicalOrderPreviewEventTimelineModel;

  dialog = true;
  panelOpen = [0];

  medicalOrderObject!: MedicalOrderPreviewEventTimelineModel;

  requiredField = FORM_VALIDATORS.REQUIRED_FIELD;

  CANCEL_BTN = FORM_CONSTANTS.BUTTON.CANCEL;
  SAVE_BTN = FORM_CONSTANTS.BUTTON.SAVE;
  MAX_WIDTH = MAX_WIDTH_MODALS;
  TITLE = MEDICAL_ORDER_CONSTANTS.TITLE_ORDER_DETAIL;
  EXT_NAME = ORDER_CONSTANTS.PREVIEW_EXAMPLE.EXTERNAL_NAME.TEXT;
  EXTERNAL_NUMBER = ORDER_CONSTANTS.LABELS.EXTERNAL_NUMBER;
  PRICE_LEVEL = ORDER_CONSTANTS.LABELS.PRICE_LEVEL;
  STATE_LABEL = ORDER_CONSTANTS.LABELS.STATE;
  DIAG_CODE = ORDER_CONSTANTS.LABELS.DIAG_CODE;
  CANCEL_VALUE = ORDER_CONSTANTS.LABELS.CANCEL_VALUE;
  SERVICE_VALUE = ORDER_CONSTANTS.LABELS.SERVICE_VALUE;
  BILL_TYPE = ORDER_CONSTANTS.LABELS.BILL_TYPE;
  CAMPUS = ORDER_CONSTANTS.LABELS.CAMPUS;
  ORDER_TYPE = ORDER_CONSTANTS.LABELS.ORDER_TYPE;
  DEFAULT_FIELDS = ORDER_CONSTANTS.DEFAULT_FIELDS;
  CUSTOM_FIELDS = ORDER_CONSTANTS.FIELDS_TITLE;
  btnClassPrimaryRound = STYLE_CLASSES.BASIC_ROUND_BTN;
  secBtnClass = STYLE_CLASSES.SECONDARY_BTN;
  primaryBtnClass = STYLE_CLASSES.PRIMARY_BTN;
  cardClass = STYLE_CLASSES.CARD;
  textFieldClass = STYLE_CLASSES.TEXT_FIELD;
  orderTypes = MEDICAL_ORDER_CONSTANTS.ORDER_TYPES;
  options = VJSF_OPTIONS;

  phoneTypeList: PhoneSchema[] = [];
  orderSchema: FullSchema = {
    type: "object",
    properties: {},
    required: []
  };
  schema: GroupFullSchema = {
    allOf: [this.orderSchema],
    type: "object"
  };
  priceLvls: ArrayByKeys[] = [];
  listData: OrderListDataView = {
    stateList: { data: [] },
    billType: { data: [] },
    campus: { data: [] },
    diagnosticPrimaryCode: { data: [] }
  };
  validCustomFields = false;
  fieldsOrder: FieldOrder[] = [];
  textfieldValidation = false;
  orderServiceValue = "";
  vjsfKey = 0;
  patientModelData: KeyValue[] = [];
  userModelData: KeyValue[] = [];
  orderCreatedBy = "";
  loadingData = true;
  medicalOrderData: MedicalOrderData = {
    externalName: "",
    state: "",
    billType: "",
    cancelValue: "0",
    diagnosticPrimaryCode: "",
    nroMedicalOrder: "",
    priceLevel: "",
    orderType: "",
    campus: "",
    model: {}
  };
  comparationStr = "";
  invalidUpdate = true;
  tempCopy?: MedicalOrderData;

  async mounted() {
    await this.getTemplate();
    await this.getPriceLevels(this.cupsId);
    await this.getSchema();
    this.fillMedicalOrderData(this.medicalOrder);
  }

  @Watch("medicalOrderData", { deep: true })
  checkUpdate() {
    if (this.comparationStr != "") {
      this.invalidUpdate =
        this.comparationStr == JSON.stringify(this.medicalOrderData);
    }
    if (
      JSON.stringify(this.medicalOrderData.model) != "{}" &&
      this.comparationStr == ""
    ) {
      const tempCopy = { ...this.tempCopy, model: this.medicalOrderData.model };
      this.comparationStr = JSON.stringify(tempCopy);
      this.invalidUpdate = false;
    }
  }
  async fillMedicalOrderData(
    medicalOrder: MedicalOrderPreviewEventTimelineModel
  ) {
    try {
      this.medicalOrderData = {
        externalName: medicalOrder.cupsPriceLevel.externalName,
        state: medicalOrder.state,
        billType: medicalOrder.billType,
        cancelValue: (medicalOrder.cancelValue || "0").toString(),
        diagnosticPrimaryCode: medicalOrder.diagnosticPrimaryCode,
        nroMedicalOrder: medicalOrder.nroMedicalOrder,
        priceLevel: medicalOrder.priceLevel,
        orderType: medicalOrder.orderType,
        campus: medicalOrder.campus,
        model: lodash.cloneDeep(this.medicalOrder.model)
      };
      this.medicalOrderData.priceLevel =
        this.priceLvls.find(p => p.name === medicalOrder.priceLevel)?.key ?? "";
      this.preloadData();
      this.setPrice();
      this.vjsfKey++;
      this.loadingData = false;
      this.tempCopy = { ...this.medicalOrderData };
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_ORDER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
      this.loadingData = false;
    }
  }

  getNameToPatientModelDataByField(fieldName: string): string {
    return this.patientModelData.find(e => e.key == fieldName)?.name ?? "";
  }

  async preloadData() {
    await this.getUsersFromOrder();
    for (const property in this.schema.allOf[0].properties) {
      if (
        (this.medicalOrderData.model[property] &&
          this.medicalOrderData.model[property] == "") ||
        !this.medicalOrderData.model[property]
      ) {
        switch (property) {
          case FIELDS_ORDER_TO_PRELOAD.CUPS:
            this.medicalOrderData.model[
              property
            ] = this.medicalOrder.cupsPriceLevel.cups;
            break;
          case FIELDS_ORDER_TO_PRELOAD.DATE_CREATED:
            this.medicalOrderData.model[
              property
            ] = this.medicalOrder.dateCreated;
            break;
          case FIELDS_ORDER_TO_PRELOAD.PATIENT_IDENTIFICATION_TYPE:
            this.medicalOrderData.model[
              property
            ] = this.getNameToPatientModelDataByField(
              FIELDS_MAPED_FROM_USER.IDENTIFICATION_TYPE
            );
            break;
          case FIELDS_ORDER_TO_PRELOAD.PATIENT_SEX:
            this.medicalOrderData.model[
              property
            ] = this.getNameToPatientModelDataByField(
              FIELDS_MAPED_FROM_USER.SEX
            );
            break;
          case FIELDS_ORDER_TO_PRELOAD.PATIENT_NAME:
            this.medicalOrderData.model[property] =
              this.getNameToPatientModelDataByField(
                FIELDS_MAPED_FROM_USER.FIRST_NAME
              ) +
              " " +
              this.getNameToPatientModelDataByField(
                FIELDS_MAPED_FROM_USER.SECOND_NAME
              );
            break;
          case FIELDS_ORDER_TO_PRELOAD.PATIENT_LASTNAME:
            this.medicalOrderData.model[property] =
              this.getNameToPatientModelDataByField(
                FIELDS_MAPED_FROM_USER.FIRST_LASTNAME
              ) +
              " " +
              this.getNameToPatientModelDataByField(
                FIELDS_MAPED_FROM_USER.SECOND_LASTNAME
              );
            break;
          case FIELDS_ORDER_TO_PRELOAD.PATIENT_PHONE:
            this.medicalOrderData.model[
              property
            ] = this.getNameToPatientModelDataByField(
              FIELDS_MAPED_FROM_USER.PHONE
            );
            break;
          case FIELDS_ORDER_TO_PRELOAD.USER_NAME:
            this.medicalOrderData.model[property] =
              this.getNameToPatientModelDataByField(
                FIELDS_MAPED_FROM_USER.FIRST_NAME
              ) +
              " " +
              this.getNameToPatientModelDataByField(
                FIELDS_MAPED_FROM_USER.SECOND_NAME
              ) +
              " " +
              this.getNameToPatientModelDataByField(
                FIELDS_MAPED_FROM_USER.FIRST_LASTNAME
              ) +
              " " +
              this.getNameToPatientModelDataByField(
                FIELDS_MAPED_FROM_USER.SECOND_LASTNAME
              );
            break;
        }
      }
    }
  }

  getFieldsModel(): MedicalOrderFieldsMap {
    const fields: MedicalOrderFieldsMap = {};
    const schemaFields: FieldMedicalOrderSchemaKey = {};
    const prop = this.schema.allOf.map(g => g.properties);

    prop.forEach(e => Object.assign(schemaFields, e));

    for (const property in this.medicalOrderData.model) {
      if (schemaFields[property]) {
        const fieldModel: MedicalOrderField = {
          title: schemaFields[property].title,
          value:
            typeof this.medicalOrderData.model[property] ==
            FORM_TEMP_CONSTANTS.FIELD_TYPE.STRING
              ? this.medicalOrderData.model[property].trim()
              : this.medicalOrderData.model[property]
        };

        switch (schemaFields[property].typeField) {
          case TYPE_FIELDS.LIST: {
            const titleOption: TitleList[] = [];
            let scoreSelectValue = null;
            const display = schemaFields[property]["x-display"];

            switch (display) {
              case FORMS_CONSTANTS.FIELD.RADIO:
              case FORMS_CONSTANTS.FIELD.SELECT: {
                const listOption = schemaFields[property].oneOf?.find(
                  item => item.const === this.medicalOrderData.model[property]
                );

                titleOption.push({
                  type: display,
                  title: listOption?.title || "",
                  value: listOption?.const || ""
                });

                scoreSelectValue = listOption?.score;
                break;
              }
              case FORMS_CONSTANTS.FIELD.CHECKBOX: {
                for (const checkItem in this.medicalOrderData.model[property]) {
                  const listOption = schemaFields[property].items?.oneOf?.find(
                    item =>
                      item.const ===
                      this.medicalOrderData.model[property][checkItem]
                  );

                  titleOption.push({
                    title: listOption?.title || "",
                    value: listOption?.const || "",
                    type: FORMS_CONSTANTS.FIELD.CHECKBOX
                  });
                }
                scoreSelectValue = null;
                break;
              }
              default: {
                throw Error;
              }
            }

            fieldModel.listTemplate = schemaFields[property].listTemplate;
            fieldModel.titleSelectValue = titleOption;
            fieldModel.scoreSelectValue = scoreSelectValue;
            break;
          }
          case TYPE_FIELDS.PHONE: {
            const indexPhone = this.phoneTypeList.findIndex(
              p => p.slot === `custom-${property}`
            );

            const phoneModel: PhoneModel = {
              countryCode: this.phoneTypeList[indexPhone].model
                ? this.phoneTypeList[indexPhone].countryCode
                : "",
              countryCallingCode: this.phoneTypeList[indexPhone].model
                ? this.phoneTypeList[indexPhone].countryCallingCode
                : "",
              model: this.phoneTypeList[indexPhone].model
            };

            fieldModel.value = this.phoneTypeList[indexPhone].formattedNumber;
            fieldModel.phoneModel = phoneModel;
            break;
          }
        }
        fields[property] = fieldModel;
      }
    }
    return fields;
  }

  async getSchema() {
    try {
      const responseData = await this.orderService.getOrderTempSchema();

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        this.schema = responseData.data;
        for (const i in this.schema.allOf[0].properties) {
          if (this.fieldsOrder.findIndex(field => field.key == i) == -1) {
            delete this.schema.allOf[0].properties[i];
          }
        }
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_ORDER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getTemplate() {
    try {
      const responseData = await this.orderService.getTemplate();

      if (responseData.code == Http.Found && responseData.data !== undefined) {
        this.fieldsOrder = responseData.data.fields;
        this.fieldsOrder = this.fieldsOrder.filter(field => {
          if (field.visible) return field;
        });

        for (const listRef of ORDER_CONSTANTS.DATA_LIST_NAMES) {
          if (responseData.data[listRef as keyof typeof responseData.data])
            await this.getListData(
              responseData.data[
                listRef as keyof typeof responseData.data
              ] as string,
              listRef
            );
        }
        this.getCampus();
      } else {
        Snackbar.popInfo(responseData.message);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_ORDER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getCampus() {
    try {
      const campusResponse = await this.campusService.getAllCampus();
      if (campusResponse.code) {
        this.listData.campus.data = campusResponse.data as {
          key: string;
          name: string;
        }[];
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_ORDER_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getListData(id: string, name: string) {
    try {
      const responseData = await this.listService.getListById(id);

      if (responseData.code === Http.Found && responseData.data !== undefined) {
        responseData.data.options.forEach(option => {
          const item =
            name === "stateList"
              ? { key: option.id, name: option.title }
              : option.title;

          this.listData[name].data.push(
            item as string & { key: string; name: string }
          );
        });
      } else {
        Snackbar.popInfo(LIST_CONSTANTS.DIALOG_MESSAGE.NOT_FOUND);
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${LIST_ACCESS.GET}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  async getPriceLevels(cupsId: string) {
    const priceLevels = await this.cupsPriceLevelService.getCupsPriceLevelById(
      cupsId
    );

    if (priceLevels.code === Http.Found && priceLevels.data) {
      this.priceLvls = Utils.getArrayByKeys(
        priceLevels.data.clients,
        SERVICES_CONTANTS.ATTRIBUTES
      );
    } else {
      this.priceLvls = [];
    }
  }

  async getUsersFromOrder() {
    const patientResponse = await this.userService.getUserById(
      this.medicalOrder.user as string
    );
    if (patientResponse.data) {
      this.patientModelData = await this.mapPropertiesUser(
        patientResponse.data
      );
    }

    const userResponse = await this.userService.getUserById(
      this.medicalOrder.createdBy as string
    );
    if (userResponse.data) {
      this.userModelData = await this.mapPropertiesUser(userResponse.data);
    }
  }

  mapPropertiesUser(userInfo: UserInformationModel) {
    const properties = userInfo.userData?.schema?.schema.allOf[0].properties;
    const phoneComponentList = userInfo.userData?.schema?.phoneComponentList;

    const modelData = [];
    for (const property in properties) {
      modelData.push({
        key: property,
        name: userInfo.userData?.fields[property] as string
      });
    }
    phoneComponentList?.forEach(phone => {
      modelData.push({
        key: phone.title,
        name: phone.model as string
      });
    });
    return modelData;
  }

  async updateMedicalOrder() {
    try {
      if ((this.$refs.formData as any).validate()) {
        const fieldsData = this.getFieldsModel();
        const medicalOrder: MedicalOrderUpdateModel = {
          orderId: this.medicalOrder.orderId!,
          state: (this.listData["stateList"].data as Array<{
            key: string;
            name: string;
          }>).find(state => state.key === this.medicalOrderData.state)?.key,
          billType: this.medicalOrderData.billType,
          cancelValue: this.medicalOrderData.cancelValue
            ? Number(this.medicalOrderData.cancelValue)
            : "",
          diagnosticPrimaryCode: this.medicalOrderData.diagnosticPrimaryCode,
          priceLevel: this.medicalOrderData.priceLevel,
          orderType: this.medicalOrderData.orderType,
          campus: this.medicalOrderData.campus,
          nroMedicalOrder: this.medicalOrderData.nroMedicalOrder,
          payment: this.orderServiceValue ? Number(this.orderServiceValue) : "",
          fields: fieldsData
        };

        this.onModalClose();

        const response = await this.medicalOrderService.updateMedicalOrder(
          medicalOrder.orderId,
          medicalOrder
        );

        if (response.code == Http.Ok) {
          Snackbar.popSuccess(response.message);
        } else {
          Snackbar.popError(response.message);
        }
      }
    } catch (error) {
      const errorMessage =
        (error as Error).message === GENERAL_CONSTANTS.FORBIDDEN
          ? `${FORM_MESSAGES.FORBIDDEN_REQUEST}${MEDICAL_ORDER_ACCESS.POST}`
          : FORM_MESSAGES.REQUEST_FAILED;

      Snackbar.popError(errorMessage);
    }
  }

  setPrice() {
    const price = this.priceLvls.find(
      p => p.key === this.medicalOrderData.priceLevel
    );
    this.orderServiceValue = price?.price;
  }

  onRequiredComplete(valid: boolean) {
    this.validCustomFields = valid;
  }

  onModalClose() {
    this.$emit(PROFILE_CONSTANTS.EMIT_OPERATIONS.CLOSE_MEDICAL_ORDER_MODAL);
    this.textfieldValidation = false;
  }

  isRequired(title: string) {
    return title.includes("*");
  }
}
